var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Spinner',{staticClass:"center pv3",attrs:{"size":"huge","line-fg-color":"#000","line-bg-color":"#fb0"}})}
var staticRenderFns = []

export { render, staticRenderFns }